/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  setChatbotFlow(inboxId, flowId) {
    return axios.post(`${this.url}/${inboxId}/set_chatbot_flow`, {
      chatbot_flow_id: flowId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  // WhatsApp QRcode (Evolution) — gestao da conexao
  setupChannelProvider(inboxId) {
    return axios.post(`${this.url}/${inboxId}/setup_channel_provider`);
  }

  refreshConnection(inboxId) {
    return axios.get(`${this.url}/${inboxId}/refresh_connection`);
  }

  regenerateQr(inboxId) {
    return axios.post(`${this.url}/${inboxId}/regenerate_qr`);
  }

  restartConnection(inboxId) {
    return axios.post(`${this.url}/${inboxId}/restart_connection`);
  }

  recreateConnection(inboxId) {
    return axios.post(`${this.url}/${inboxId}/recreate_connection`);
  }

  disconnectChannelProvider(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disconnect_channel_provider`);
  }
}

export default new Inboxes();
